import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
})
export class LoaderComponent implements OnInit {
  public show: boolean = true;

  constructor() {
    setTimeout(() => {
      this.show = false;
    }, 2000);
  }

  ngOnInit() {}

  ngOnDestroy() {}
}
